import { render, staticRenderFns } from "./ContentBrokenCard.vue?vue&type=template&id=58814048&"
import script from "./ContentBrokenCard.ts?vue&type=script&lang=ts&"
export * from "./ContentBrokenCard.ts?vue&type=script&lang=ts&"
import style0 from "./ContentBrokenCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports